import React from "react"
import {IndexRoute, Link, Redirect, Route, Switch, withRouter} from "react-router-dom";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";
import {loadLifeAtInnogy} from "../../actions/actions";
import ContentUnitListItem from "../content-unit/list-item";
import {Progress} from "reactstrap";
import Loading from "../../../../common/js/components/loading";
import Notifications from "../../../../common/js/notifications/components/notifications";
import ProgressWithIcon from "../../../../common/js/components/progress-with-icon";
import ProgressWithoutIcon from "../../../../common/js/components/progress-without-icon";

class LifeAtInnogyList extends React.Component {

    componentWillMount() {
        this.props.loadLifeAtInnogy('api/v1/candidate_accounts');
    }

    render() {
        let life_at_innogy = this.props.life_at_innogy.list || [];
        let incomplete = life_at_innogy
            .filter(item => item.state !== 'complete')
            .sort((itemA, itemB) => { return (itemA.position - itemB.position) })
            .map((assignment) => <ContentUnitListItem assignment={assignment} key={assignment.id}/>);

        let complete = life_at_innogy.filter(item => item.state === 'complete')
            .filter(item => item.state === 'complete')
            .sort((itemA, itemB) => { return (itemA.position - itemB.position) })
            .map((assignment) => <ContentUnitListItem assignment={assignment} key={assignment.id}/>);

        return (
            <div className='main-content bg-gray'>
                <Notifications container={true} app='candidate'/>
                <section className='bg-gray pt-5 pb-4'>
                    <div className='container'>
                        <hr className='gasnet-divider'/>
                        <FormattedMessage id='app.life_at_innogy.title'>{(txt) => (<h1>{txt}</h1>)}</FormattedMessage>
                        <p><FormattedMessage id='app.life_at_innogy.info_text'/></p>
                    </div>
                </section>
                <section className='bg-gray pt-4 pb-4'>
                    <div className='container'>
                        <ProgressWithoutIcon progress={{value: this.props.life_at_innogy.progress, max: 1}}/>
                    </div>
                </section>
                <section className='bg-gray pt-4 pb-4'>
                    <div className='container'>
                        { this.props.life_at_innogy.loading && <Loading/> }
                        { incomplete.length > 0 && <h3 className='pt-2 pb-2'><FormattedMessage id='app.content_units.title.incomplete'/></h3> }
                        { incomplete }
                        { complete.length > 0 && <h3 className='pt-2 pb-2'><FormattedMessage id='app.content_units.title.complete'/></h3> }
                        { complete }
                    </div>
                </section>
            </div>
        )
    };
}

function mapStateToProps(state,ownProps) {
    return {
        life_at_innogy: state.life_at_innogy
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({
        loadLifeAtInnogy: loadLifeAtInnogy
    }, dispatch);
}

export default withRouter(connect(mapStateToProps, matchDispatchToProps)(LifeAtInnogyList));
